import type { CSSProperties } from 'react';
import zoomUrl from '@/assets/svg/location/zoom.svg';

interface LocationIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
}

/**
 * The Zoom location logo.
 *
 * This was a generated SVG component that inlined a raster image as base64
 * inside the SVG — 96 KB of JavaScript (43.7 KB gzipped) to draw a 20x20 logo.
 * Thirteen modules import it, several of them eagerly reachable, so it sat in
 * the entry chunk for every visitor. Serving the `.svg` by URL moves those bytes
 * out of the bundle and lets the browser cache the image separately.
 *
 * Kept as a component with the same default export and the same intrinsic 20x20
 * so no call site changes. Chakra's `<Icon as={Zoom} />` styles it through
 * `className`, which is why that prop is forwarded — its CSS width/height wins
 * over the attributes below, exactly as it did over the old `<svg>`.
 *
 * `alt` is empty because every call site pairs the icon with a text label.
 */
const ZoomLocationIcon = ({
  width = 20,
  height = 20,
  className,
  style,
}: LocationIconProps) => (
  <img
    src={zoomUrl}
    alt=""
    width={width}
    height={height}
    className={className}
    style={{ objectFit: 'contain', ...style }}
  />
);

export default ZoomLocationIcon;
